module.exports = __webpack_public_path__ + "img/hair_back_male_medium.de907fc2.png";